import { createContext, useContext } from 'react';

export const MiniPlayerContext = createContext(null);
export const useMiniPlayer = () => useContext(MiniPlayerContext);